/**
 * @typedef KeywordHelpProps
 * @property {() => void} [closeModal]
**/

/**
* This only seems to be used as a modal, but the component is setup to be a page too so lets keep that for now.
* @param {KeywordHelpProps | undefined} props
**/
const KeywordHelpPage = (props) => {

    const isModal = props.closeModal ? true : false;

    return <div className={isModal ? "schedule-modal" : ''} onClick={() => props?.closeModal && props.closeModal()}>
        <div className={isModal ? "schedule-modal-content search-help-modal" : ''} onClick={(e) => e.stopPropagation()}>
            {isModal &&
                <div className='search-help-header'>
                    <div className='title'>Keyword Notifications</div>
                    <button onClick={() => props.closeModal()} className="close-cross" aria-label="close modal" />
                </div>
            }
            <div className="long-paragraph-text">
                <div>
                    <h3 className="txt-dark-blue first-header">Single Keyword</h3>
                    <p className="no-margin"><b>Example: distilled</b></p>
                    <p>A single keyword is the simplest of all search statement constructions. For a document to qualify, it must contain an occurrence of the exact character string specified as the keyword. For example, the word "distilled" only retrieves the documents that contain occurrences of the word "distilled". The words "distill" and "distillery", for example, do not qualify. However, using the word "distill" will retrieve documents that contain occurrences of the word "distill", "distilled" and "distillery".</p>
                </div>
                <div>
                    <h3 className="txt-dark-blue">Keyword Logic Conditions</h3>
                    <p><b>Keyword statements can be entered using two logic conditions: "and" or "or". </b>Use of a logic condition requires two statements. For example, "A and B", or "A or B". The logic conditions must be positioned between two keywords.</p>
                    <p>When you use "and" in your statement (example: "A and B"), all documents that contain references of both A and B are included in your notification. Documents containing references of only A or only B will not qualify.</p>
                    <p>When you use "or" in your search statement (example: "A or B"), all documents with references of either A or B will be included in your notification. Unlike "and" it is not necessary for both statements to be present in a document for it to qualify, but documents containing both "A and B" will also qualify.</p>
                </div>
            </div>
        </div>
    </div>
}

export default KeywordHelpPage;
